"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./lib/util");
exports.listReducers = function (definition) {
    var keyOf = function (selector) {
        return typeof selector === "string" ? selector : definition.list.key(selector);
    };
    return definition.addReducers({
        remove: function (data, item) {
            if (data == undefined) {
                util_1.warn('Trying to remove from collection that is null or undefined. The action will be ignored.');
                return data;
            }
            var index = data.findIndex(function (val) { return keyOf(val) == keyOf(item); });
            if (index == -1) {
                util_1.warn("Trying to remove element " + keyOf(item) + " from collection that does not contain it. The action will be ignored.");
                return data;
            }
            var result = data.slice();
            result.splice(index, 1);
            return result;
        },
        pushOrReplace: function (data, item) {
            if (data == undefined) {
                util_1.warn('Trying to push to collection that is null or undefined. The action will be ignored.');
                return data;
            }
            var index = data.findIndex(function (val) { return keyOf(val) == keyOf(item); });
            if (index == -1) {
                return data.concat([item]);
            }
            var result = data.slice();
            result.splice(index, 1, item);
            return result;
        },
    });
};
exports.setValueReducer = function (definition) {
    return definition.addReducers({
        setValue: function (_data, setValue) { return setValue; },
    });
};
exports.objectReducers = function (definition) {
    return definition.addReducers({
        update: function (data, update) {
            if (data == undefined) {
                util_1.warn('Trying to update object that is undefined. The action will be ignored.');
                return data;
            }
            return __assign({}, data, update);
        }
    });
};
